import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Avatar, Empty, Skeleton, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Text } = Typography;
const cloudFrontKey = process.env.REACT_APP_CLOUDFRONT_KEY;

const UsersPoints = (props: any) => {
  const {
    userPoints,
    userPointsLoading,
    actions: { getUserPoints },
  } = props;

  const { id: currentUserId } = useParams();
  const [users, setUsers] = useState<any>([]);

  useEffect(() => {
    getUserPoints();
  }, []);

  useEffect(() => {
    if (!userPoints) return;
    setUsers(
      userPoints
        .filter((user: any) => user)
        .sort((a: any, b: any) => b?.points - a?.points)
    );
  }, [userPoints]);

  if (userPointsLoading) {
    return (
      <div>
        <Skeleton active paragraph={{ rows: 5 }} />
      </div>
    );
  }
  return (
    <div>
      <div className="text-neutral-600 font-semibold text-base mb-4">
        Points
      </div>
      <div className="max-h-[150px] overflow-y-auto">
        {users && users.length > 0 ? (
          users.map((user: any) => (
            <div
              key={user.userId}
              className={`w-full h-[50px] rounded-lg flex items-center px-4 mb-1 justify-between ${
                currentUserId === user.userId
                  ? "bg-primary-100"
                  : "bg-neutral-100"
              }`}
            >
              <div>
                <Avatar
                  icon={<UserOutlined />}
                  src={
                    user?.profilePictureKey
                      ? `${cloudFrontKey}/${user.profilePictureKey}`
                      : ""
                  }
                />

                <Text className="text-neutral-600 font-semibold text-sm leading-4 ml-3">
                  {user.name}
                </Text>
              </div>

              <div className="text-primary-600 font-bold text-base">
                {user.points}
              </div>
            </div>
          ))
        ) : (
          <Empty className="py-6" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </div>
    </div>
  );
};

export default UsersPoints;
